import ProfileContainer from './Profile.container';

export default ProfileContainer;
